export default "__VITE_ASSET__DLEUb5rt__"